const Brand = {
    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "brand": "العلامة التجارية",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء اختيار الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",

};

export default Brand;
